

import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class SubscriptionStatusGuard implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        return this.verifySubscribedNotExpired();
    }

    verifySubscribedNotExpired(): boolean {
        const status = this.authService.getSubscriptionStatus();
        if (!status || (status && status === 'expired')) {
            this.router.navigate(['/subscription']);
            return false;
        }
        return true;
    }
}
